// THIS FILE CONTENT SHOULD BE REPLACE ON CI BUILD WITH ~{env}.config.ts
import { config as localDev } from '@app/componentlib/config/localDev.config' // For testing locally
import { config as dev } from '@app/componentlib/config/dev.config' // For testing with a dev server

const using = localDev
//Override envoirment and name - so that we always know where we are!
using.environment = localDev.environment // On Localhost - even with prod config, environment name is 'localDev'
using.app.name = localDev.environment // On Localhost - even with prod config, name is 'localDev'

export const config = using